app.controller('CameraController', function ($scope, $uibModalInstance, items, uibDateParser, $http, $window, $location, $timeout, Upload, $q, $cookies, $translate, deviceDetector) {

    $scope.items = items;
    $scope.camfacing = 'env';
    $scope.ktpPhoto = '';

    $scope.device = deviceDetector;
    $scope.isMobile = $scope.device.isMobile();
    $scope.useCam = true;

    $scope.KTPconfig = {
        //viewerWidth: 300,
        //viewerHeight: 300,
        //outputWidth: 300,
        //outputHeight: 300,
        delay: 0,
        shots: 1,
        countdown: 0,
        flashFallbackUrl: 'vendors/webcamjs/webcam.swf',
        shutterUrl: 'shutter.mp3',
        flashNotDetectedText: 'Camera not found or use Chrome Browser'
    };

    //$scope.$broadcast('ngWebcam_hasmedia');
    console.log($scope.$broadcast('ngWebcam_hasmedia'));

    $scope.switchCam = function () {
        console.log($scope.camfacing);
        if ($scope.camfacing == 'env') {
            console.log('cam1');
            $scope.$broadcast('ngWebcam_camUsr');
            $scope.camfacing = 'usr'
        }
        else {
            console.log('cam1');
            $scope.$broadcast('ngWebcam_camEnv');
            $scope.camfacing = 'env'
        }

        console.log($scope.camfacing);
    }

    $scope.KTPonCaptureComplete = function (src) {
        console.log(src);
        $scope.ktpPhoto = src[0];
        $uibModalInstance.close($scope.ktpPhoto);
        //var el = document.getElementById('result');
        //var img = document.createElement('img');
        //img.src = src[$scope.KTPconfig.shots - 1];
        //img.width = 240;
        //img.height = 180;
        //el.appendChild(img);
    };

    $scope.KTPonError = function (err) {
        //console.log('err', err);
        //$scope.useCam = false;
        swal("error", 'Hanya diperbolehkan capture melalui perangkat kamera. Periksa kembali perangkat kamera Anda. Atau lanjutkan menggunakan perangkat handphone', 'info');
        $uibModalInstance.dismiss('cancel');
    };

    $scope.KTPonLoad = function () {
        // $log.info('ktp.onLoad');
    };

    $scope.KTPcapture = function () {
        $scope.$broadcast('ngWebcam_capture');
    };

    $scope.KTPon = function () {
        $scope.$broadcast('ngWebcam_on');
    };

    $scope.KTPoff = function () {
        $scope.$broadcast('ngWebcam_off');
        $scope.captureButtonEnable = false;
    };

    $scope.KTPremove = function () {
        $scope.ktpPhoto = '';
    }

    $scope.allowedExt = ['.jpg', '.jpeg', '.bmp', '.png'];


    $scope.filenameKTP = "";
    $scope.fileKTP = "";
    $scope.fileKTPext = "";
    $scope.KTPFile = [];



    $scope.selectKTP = function (files) {

        if (files.length > 0) {
            console.log('files', files);
            $scope.KTPFile = files;
            let allowed = true;
            var reader = new FileReader();

            reader.onload = function (e) {
                if (allowed) {
                    $scope.fileKTP = btoa(e.target.result.toString());
                    $uibModalInstance.close($scope.fileKTP);
                }
            };
            console.log('gambar', $scope.KTPFile);
            reader.readAsBinaryString(files[0]);
            $scope.fileKTPext = files[0].name.substr(files[0].name.lastIndexOf('.'));

            if ($scope.allowedExt.indexOf($scope.fileKTPext.toLowerCase()) < 0) {
                allowed = false;
                $scope.fileKTPext = '';
                $scope.KTPFile = '';
                alert("Extensi yang dibolehkan : " + $scope.allowedExt);
            }
            else
                $scope.filenameKTP = files[0].name;
        }
        else
            console.log('file not found');
    };


    $scope.clickRemoveKTP = function (file, event, key) {
        event.preventDefault();
        $scope.fileKTP = "";
        $scope.filenameKTP = "";
        $scope.fileKTPext = "x";
        $scope.KTPFile.splice(key, 1);
        $scope.KTPFile = [];
        return null;
    };



    $scope.ok = function () {
        $uibModalInstance.close($scope.item);
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };



});



app.controller('BrowseController', function ($scope, $uibModalInstance, items, uibDateParser, $http, $window, $location, $timeout, Upload, $q, $cookies, $translate) {

    $scope.items = items;
    $scope.allowedExt = ['.jpg', '.jpeg', '.bmp', '.png'];


    $scope.filenameKTP = "";
    $scope.fileKTP = "";
    $scope.fileKTPext = "";
    $scope.KTPFile = [];



    $scope.selectKTP = function (files) {

        if (files.length > 0) {
            console.log('files', files);
            $scope.KTPFile = files;
            let allowed = true;
            var reader = new FileReader();

            reader.onload = function (e) {
                if (allowed) {
                    $scope.fileKTP = btoa(e.target.result.toString());
                    $uibModalInstance.close($scope.fileKTP);
                }
            };
            console.log('gambar', $scope.KTPFile);
            reader.readAsBinaryString(files[0]);
            $scope.fileKTPext = files[0].name.substr(files[0].name.lastIndexOf('.'));

            if ($scope.allowedExt.indexOf($scope.fileKTPext.toLowerCase()) < 0) {
                allowed = false;
                $scope.fileKTPext = '';
                $scope.KTPFile = '';
                alert("Extensi yang dibolehkan : " + $scope.allowedExt);
            }
            else
                $scope.filenameKTP = files[0].name;
        }
        else
            console.log('file not found');
    };


    $scope.clickRemoveKTP = function (file, event, key) {
        event.preventDefault();
        $scope.fileKTP = "";
        $scope.filenameKTP = "";
        $scope.fileKTPext = "x";
        $scope.KTPFile.splice(key, 1);
        $scope.KTPFile = [];
        return null;
    };
});